import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import { getCardCode, saveCardCode } from "../services/cardCodeService";

class CardCodeForm extends Form {
  state = {
    data: {
      name: "",
      code: "",
      rate: "",
    },
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    name: Joi.string().required().label("Card"),
    code: Joi.string().required().label("Card Code"),
    rate: Joi.number().required().label("Rate"),
    completionTime: Joi.string().required().label("Completion time"),
  };

  async populateCardCode() {
    try {
      const cardCodeId = this.props.match.params.id;
      if (cardCodeId === "new") return;

      const { data: ccode } = await getCardCode(cardCodeId);
      this.setState({ data: this.mapToViewModel(ccode) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        return this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateCardCode();
  }

  mapToViewModel(ccode) {
    return {
      _id: ccode._id,
      name: ccode.name,
      code: ccode.code,
      rate: ccode.rate,
      completionTime: ccode.completionTime,
    };
  }

  doSubmit = async () => {
    const { data } = this.state;
    // Call the server

    await saveCardCode(data);

    this.props.history.push("/card-codes");
  };

  render() {
    const cardCodeId = this.props.match.params.id;
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + "px" }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + "px", fontWeight: "bold" }}
            >
              Create a Card Code
            </h4>
            <p style={{ color: "#000524" }}>
              This operation can only be performed by Jeroid Admin
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + "%" }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: "white",
                borderBottom: 0,
                marginTop: 2 + "%",
                fontWeight: "bold",
              }}
            >
              Card Info
            </div>
            <hr
              style={{
                marginRight: 20 + "px",
                marginLeft: 20 + "px",
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="col-md-6">
                    {this.renderInput(
                      "code",
                      "Card Code",
                      "",
                      "autofocus",
                      "text"
                    )}
                  </div>
                  <div className="col-md-6">
                    {this.renderInput("rate", "Rate", "", "", "number")}
                  </div>
                </div>

                <div className="form-row">
                  <div className="col-md-8">
                    {this.renderInput("name", "Card Name", "", "", "text")}
                  </div>
                  <div className="col-md-4">
                    {this.renderInput(
                      "completionTime",
                      "Completion Time",
                      "",
                      "",
                      "text"
                    )}
                  </div>
                </div>

                <div className="text-center">
                  {cardCodeId === "new"
                    ? this.renderButton("Save")
                    : this.renderButton("Update")}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CardCodeForm;
